(function () {
  "use strict";

  // ---- Konfiguration: hier anpassen, kein Code-Wissen nötig ----
  var CONFIG = {
    COLOGNE_LAT: 50.9413,
    COLOGNE_LON: 6.9583,
    MAX_DISTANCE_KM: 30,
    SLOT_START_HOUR: 10,
    SLOT_START_MINUTE: 0,
    SLOT_END_HOUR: 18,
    SLOT_END_MINUTE: 0,
    SLOT_INTERVAL_MIN: 30, // Abstand zwischen zwei buchbaren Terminstart-Zeiten
    MIN_LEAD_BUSINESS_DAYS: 2,
    MAX_HORIZON_WEEKS: 4,
    CONTACT_URL: "/pages/contact",
    BLOCKED_DATES: [], // z.B. ["2026-12-24", "2026-12-31"] fuer Feiertage/Urlaub
    // Manuell pflegen, sobald ihr einen Kundentermin bestaetigt: blockiert
    // diesen Slot und die naechste Stunde fuer alle anderen Kunden, damit
    // genug Puffer zwischen zwei Aufmassterminen bleibt.
    // Beispiel: { date: "2026-09-22", time: "10:30" } blockiert 10:30 und
    // 11:00 Uhr am 22.09.2026 - der naechste waehlbare Slot ist 11:30 Uhr.
    CONFIRMED_BOOKINGS: [],
    CONFIRMED_BOOKING_BUFFER_MIN: 60,
    GEOCODE_TIMEOUT_MS: 4000,
    // Web3Forms verschickt die Anfrage direkt an support@plisstek.de, getrennt
    // vom normalen Shopify-Kontaktformular. Access Key kostenlos erstellen
    // auf https://web3forms.com (E-Mail support@plisstek.de eintragen und
    // bestaetigen, den generierten Access Key hier eintragen).
    WEB3FORMS_ACCESS_KEY: "daa1279f-22df-4166-83a9-4506650040cb",
    WEB3FORMS_ENDPOINT: "https://api.web3forms.com/submit"
  };

  // Fallback-Koordinaten (Groburlaub-Netz), falls die Live-Abfrage
  // (api.zippopotam.us) nicht erreichbar ist. Deckt den Grossraum
  // Koeln plus ein paar Referenzstaedte ausserhalb ab.
  var PLZ_FALLBACK = {
    "50667": { lat: 50.9375, lon: 6.9603, ort: "Köln" },
    "50823": { lat: 50.9583, lon: 6.9203, ort: "Köln" },
    "50968": { lat: 50.9089, lon: 6.9635, ort: "Köln" },
    "51103": { lat: 50.9394, lon: 7.0192, ort: "Köln" },
    "51147": { lat: 50.8864, lon: 7.0631, ort: "Köln" },
    "51065": { lat: 50.9614, lon: 7.0089, ort: "Köln" },
    "50937": { lat: 50.9308, lon: 6.9231, ort: "Köln" },
    "50733": { lat: 50.9694, lon: 6.9553, ort: "Köln" },
    "51373": { lat: 51.0459, lon: 6.9861, ort: "Leverkusen" },
    "51427": { lat: 50.9925, lon: 7.1358, ort: "Bergisch Gladbach" },
    "53757": { lat: 50.7797, lon: 7.2003, ort: "Sankt Augustin" },
    "53840": { lat: 50.8144, lon: 7.1594, ort: "Troisdorf" },
    "53721": { lat: 50.7975, lon: 7.2028, ort: "Siegburg" },
    "53639": { lat: 50.6822, lon: 7.1839, ort: "Königswinter" },
    "41539": { lat: 51.0958, lon: 6.8397, ort: "Dormagen" },
    "40210": { lat: 51.2277, lon: 6.7735, ort: "Düsseldorf" },
    "42103": { lat: 51.2562, lon: 7.1508, ort: "Wuppertal" },
    "42651": { lat: 51.1652, lon: 7.0671, ort: "Solingen" },
    "52062": { lat: 50.7753, lon: 6.0839, ort: "Aachen" },
    "41061": { lat: 51.1805, lon: 6.4428, ort: "Mönchengladbach" },
    "53879": { lat: 50.6605, lon: 6.7898, ort: "Euskirchen" },
    "52349": { lat: 50.8047, lon: 6.4832, ort: "Düren" },
    "51643": { lat: 51.0303, lon: 7.5661, ort: "Gummersbach" },
    "10115": { lat: 52.5321, lon: 13.3849, ort: "Berlin" },
    "80331": { lat: 48.1372, lon: 11.5755, ort: "München" },
    "20095": { lat: 53.5507, lon: 9.9937, ort: "Hamburg" },
    "60311": { lat: 50.1109, lon: 8.6821, ort: "Frankfurt am Main" }
  };

  function haversineKm(lat1, lon1, lat2, lon2) {
    var R = 6371;
    var dLat = ((lat2 - lat1) * Math.PI) / 180;
    var dLon = ((lon2 - lon1) * Math.PI) / 180;
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos((lat1 * Math.PI) / 180) *
        Math.cos((lat2 * Math.PI) / 180) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  }

  function fetchWithTimeout(url, ms) {
    return new Promise(function (resolve, reject) {
      var timer = setTimeout(function () {
        reject(new Error("timeout"));
      }, ms);
      fetch(url)
        .then(function (res) {
          clearTimeout(timer);
          resolve(res);
        })
        .catch(function (err) {
          clearTimeout(timer);
          reject(err);
        });
    });
  }

  // Alle offiziellen Postleitzahlen der Stadt Koeln: werden immer als
  // "innerhalb" behandelt, unabhaengig von Live-API oder Fallback-Tabelle.
  var KOELN_PLZ = [
    "50667", "50668", "50670", "50672", "50674", "50676", "50677", "50678", "50679",
    "50733", "50735", "50737", "50739",
    "50765", "50767", "50769",
    "50823", "50825", "50827", "50829",
    "50858", "50859",
    "50931", "50933", "50935", "50937", "50939", "50941",
    "50968", "50969",
    "50996", "50997", "50999",
    "51061", "51063", "51065", "51067", "51069",
    "51101", "51103", "51105", "51107", "51109",
    "51143", "51145", "51147", "51149"
  ];

  // Alle offiziellen Postleitzahlen des gesamten Rhein-Erft-Kreises (alle 10
  // Staedte/Gemeinden: Bedburg, Bergheim, Bruehl, Elsdorf, Erftstadt,
  // Frechen, Huerth, Kerpen, Pulheim, Wesseling): werden genau wie die
  // Koelner PLZ oben immer als "innerhalb" behandelt, unabhaengig von
  // Live-API oder Fallback-Tabelle.
  var RHEIN_ERFT_PLZ = {
    "50126": "Bergheim",
    "50127": "Bergheim",
    "50128": "Bergheim",
    "50129": "Bergheim",
    "50169": "Kerpen",
    "50170": "Kerpen",
    "50171": "Kerpen",
    "50181": "Bedburg",
    "50189": "Elsdorf",
    "50226": "Frechen",
    "50259": "Pulheim",
    "50321": "Brühl",
    "50354": "Hürth",
    "50374": "Erftstadt",
    "50389": "Wesseling"
  };

  // Alle offiziellen Postleitzahlen der Stadt Bonn: werden genau wie die
  // Koelner PLZ und der Rhein-Erft-Kreis oben immer als "innerhalb"
  // behandelt, unabhaengig von Live-API, Fallback-Tabelle oder tatsaechlicher
  // Distanz (einzelne Bonner Stadtteile wie Bad Godesberg liegen laut
  // Berechnung knapp ueber den sonst geltenden 30 km).
  var BONN_PLZ = [
    "53111", "53113", "53115", "53117", "53119",
    "53121", "53123", "53125", "53127", "53129",
    "53173", "53175", "53177", "53179",
    "53225", "53227", "53229"
  ];

  // Liefert {lat, lon, ort} oder null (PLZ nicht gefunden / API+Fallback leer)
  function lookupPLZ(plz) {
    if (KOELN_PLZ.indexOf(plz) !== -1) {
      return Promise.resolve({ lat: CONFIG.COLOGNE_LAT, lon: CONFIG.COLOGNE_LON, ort: "Köln" });
    }
    if (Object.prototype.hasOwnProperty.call(RHEIN_ERFT_PLZ, plz)) {
      return Promise.resolve({ lat: CONFIG.COLOGNE_LAT, lon: CONFIG.COLOGNE_LON, ort: RHEIN_ERFT_PLZ[plz] });
    }
    if (BONN_PLZ.indexOf(plz) !== -1) {
      return Promise.resolve({ lat: CONFIG.COLOGNE_LAT, lon: CONFIG.COLOGNE_LON, ort: "Bonn" });
    }
    var url = "https://api.zippopotam.us/de/" + encodeURIComponent(plz);
    return fetchWithTimeout(url, CONFIG.GEOCODE_TIMEOUT_MS)
      .then(function (res) {
        if (!res.ok) throw new Error("not found");
        return res.json();
      })
      .then(function (data) {
        var place = data && data.places && data.places[0];
        if (!place) return null;
        return {
          lat: parseFloat(place.latitude),
          lon: parseFloat(place.longitude),
          ort: place["place name"]
        };
      })
      .catch(function () {
        return PLZ_FALLBACK[plz] || null;
      });
  }

  function isBusinessDay(date) {
    var day = date.getDay();
    return day !== 0 && day !== 6;
  }

  function addBusinessDays(date, days) {
    var result = new Date(date);
    var added = 0;
    while (added < days) {
      result.setDate(result.getDate() + 1);
      if (isBusinessDay(result)) added++;
    }
    return result;
  }

  function toISODate(date) {
    // Lokales Datum, nicht toISOString() (das rechnet auf UTC um und
    // wuerde nahe Mitternacht in Deutschland auf den Vortag springen).
    var y = date.getFullYear();
    var m = String(date.getMonth() + 1).padStart(2, "0");
    var d = String(date.getDate()).padStart(2, "0");
    return y + "-" + m + "-" + d;
  }

  function generateAvailableDates() {
    var dates = [];
    var start = addBusinessDays(new Date(), CONFIG.MIN_LEAD_BUSINESS_DAYS);
    start.setHours(0, 0, 0, 0);
    var horizonEnd = new Date();
    horizonEnd.setDate(horizonEnd.getDate() + CONFIG.MAX_HORIZON_WEEKS * 7);
    var cursor = new Date(start);
    while (cursor <= horizonEnd) {
      if (isBusinessDay(cursor) && CONFIG.BLOCKED_DATES.indexOf(toISODate(cursor)) === -1) {
        dates.push(new Date(cursor));
      }
      cursor.setDate(cursor.getDate() + 1);
    }
    return dates;
  }

  function generateSlots() {
    var slots = [];
    var startTotal = CONFIG.SLOT_START_HOUR * 60 + CONFIG.SLOT_START_MINUTE;
    var endTotal = CONFIG.SLOT_END_HOUR * 60 + CONFIG.SLOT_END_MINUTE;
    for (var t = startTotal; t + CONFIG.SLOT_INTERVAL_MIN <= endTotal; t += CONFIG.SLOT_INTERVAL_MIN) {
      var h = Math.floor(t / 60);
      var m = t % 60;
      slots.push(String(h).padStart(2, "0") + ":" + String(m).padStart(2, "0"));
    }
    return slots;
  }

  function toMinutes(hhmm) {
    var parts = hhmm.split(":");
    return parseInt(parts[0], 10) * 60 + parseInt(parts[1], 10);
  }

  // Ein Slot ist blockiert, wenn er auf denselben Tag faellt wie ein
  // bestaetigter Termin und innerhalb von CONFIRMED_BOOKING_BUFFER_MIN
  // (Minuten) nach dessen Start liegt.
  function isSlotBlocked(dateISO, slot) {
    var slotMinutes = toMinutes(slot);
    return CONFIG.CONFIRMED_BOOKINGS.some(function (booking) {
      if (booking.date !== dateISO) return false;
      var bookedMinutes = toMinutes(booking.time);
      return slotMinutes >= bookedMinutes && slotMinutes < bookedMinutes + CONFIG.CONFIRMED_BOOKING_BUFFER_MIN;
    });
  }

  var WEEKDAY_NAMES = ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"];
  var MONTH_NAMES = [
    "Januar", "Februar", "März", "April", "Mai", "Juni",
    "Juli", "August", "September", "Oktober", "November", "Dezember"
  ];

  function formatDateShort(date) {
    return WEEKDAY_NAMES[date.getDay()] + ", " + date.getDate() + "." + (date.getMonth() + 1) + ".";
  }

  function formatDateLong(date) {
    return WEEKDAY_NAMES[date.getDay()] + ", " + date.getDate() + ". " + MONTH_NAMES[date.getMonth()] + " " + date.getFullYear();
  }

  document.addEventListener("DOMContentLoaded", function () {
    var app = document.getElementById("aufmass-app");
    if (!app) return;

    var state = { plzInfo: null, selectedDate: null, selectedTime: null };

    app.innerHTML =
      '<div class="aufmass-step" id="step-plz">' +
      "<h2>1. Servicegebiet prüfen</h2>" +
      "<p>Der kostenlose Aufmaßservice ist aktuell nur in Köln und Umgebung (30 km Umkreis) verfügbar.</p>" +
      '<div class="aufmass-plz-row">' +
      '<input type="text" id="plz-input" inputmode="numeric" pattern="[0-9]{5}" maxlength="5" placeholder="PLZ, z. B. 50667">' +
      '<button type="button" id="plz-check-btn" class="aufmass-btn aufmass-btn-primary">Prüfen</button>' +
      "</div>" +
      '<div id="plz-status" class="aufmass-status" aria-live="polite"></div>' +
      "</div>" +
      '<div class="aufmass-step" id="step-date" hidden>' +
      "<h2>2. Datum wählen</h2>" +
      '<div id="date-list" class="aufmass-date-list"></div>' +
      "</div>" +
      '<div class="aufmass-step" id="step-time" hidden>' +
      "<h2>3. Uhrzeit wählen</h2>" +
      '<div id="time-list" class="aufmass-time-list"></div>' +
      "</div>" +
      '<div class="aufmass-step" id="step-summary" hidden>' +
      "<h2>4. Ihre Daten</h2>" +
      '<div class="aufmass-summary-box" id="summary-text"></div>' +
      '<button type="button" id="change-selection-btn" class="aufmass-btn aufmass-btn-secondary">Termin ändern</button>' +
      "</div>";

    var plzInput = document.getElementById("plz-input");
    var plzBtn = document.getElementById("plz-check-btn");
    var plzStatus = document.getElementById("plz-status");
    var stepDate = document.getElementById("step-date");
    var stepTime = document.getElementById("step-time");
    var stepSummary = document.getElementById("step-summary");
    var dateList = document.getElementById("date-list");
    var timeList = document.getElementById("time-list");
    var summaryText = document.getElementById("summary-text");
    var changeBtn = document.getElementById("change-selection-btn");

    var form = document.getElementById("aufmass-form");
    var formErrors = document.getElementById("aufmass-form-errors");
    var successBox = document.getElementById("aufmass-success");
    var submitBtn = document.getElementById("aufmass-submit-btn");
    var fieldDatum = document.getElementById("field-datum");
    var fieldUhrzeit = document.getElementById("field-uhrzeit");
    var fieldName = document.getElementById("ContactFormName");
    var fieldStrasse = document.getElementById("ContactFormStrasse");
    var fieldPLZ = document.getElementById("ContactFormPLZ");
    var fieldOrt = document.getElementById("ContactFormOrt");
    var fieldPhone = document.getElementById("ContactFormPhone");
    var fieldEmail = document.getElementById("ContactFormEmail");
    var fieldNote = document.getElementById("ContactFormNote");
    var fieldBotcheck = document.getElementById("aufmass-botcheck");

    function showError(message) {
      plzStatus.dataset.state = "error";
      plzStatus.innerHTML = "";
      var box = document.createElement("div");
      box.className = "aufmass-error-box";
      box.appendChild(document.createTextNode(message + " "));
      var link = document.createElement("a");
      link.href = CONFIG.CONTACT_URL;
      link.textContent = "Zum Kontaktformular";
      box.appendChild(link);
      plzStatus.appendChild(box);
      stepDate.hidden = true;
      stepTime.hidden = true;
      stepSummary.hidden = true;
      if (form) form.classList.add("is-hidden");
    }

    function showChecking() {
      plzStatus.dataset.state = "checking";
      plzStatus.textContent = "Wird geprüft …";
    }

    function showOk(ort, distanceKm) {
      plzStatus.dataset.state = "ok";
      plzStatus.textContent =
        "Servicegebiet bestätigt ✓ (" + ort + ", ca. " + Math.round(distanceKm) + " km ab Köln)";
    }

    function renderDates() {
      var dates = generateAvailableDates();
      dateList.innerHTML = "";
      dates.forEach(function (date) {
        var pill = document.createElement("button");
        pill.type = "button";
        pill.className = "aufmass-pill";
        pill.setAttribute("aria-pressed", "false");
        pill.textContent = formatDateShort(date);
        pill.addEventListener("click", function () {
          state.selectedDate = date;
          state.selectedTime = null;
          Array.prototype.forEach.call(dateList.children, function (el) {
            el.classList.remove("is-selected");
            el.setAttribute("aria-pressed", "false");
          });
          pill.classList.add("is-selected");
          pill.setAttribute("aria-pressed", "true");
          renderTimes();
          stepTime.hidden = false;
          stepSummary.hidden = true;
          if (form) form.classList.add("is-hidden");
        });
        dateList.appendChild(pill);
      });
    }

    function renderTimes() {
      var slots = generateSlots();
      var dateISO = toISODate(state.selectedDate);
      timeList.innerHTML = "";
      slots.forEach(function (slot) {
        if (isSlotBlocked(dateISO, slot)) return;
        var pill = document.createElement("button");
        pill.type = "button";
        pill.className = "aufmass-pill";
        pill.setAttribute("aria-pressed", "false");
        pill.textContent = slot + " Uhr";
        pill.addEventListener("click", function () {
          state.selectedTime = slot;
          Array.prototype.forEach.call(timeList.children, function (el) {
            el.classList.remove("is-selected");
            el.setAttribute("aria-pressed", "false");
          });
          pill.classList.add("is-selected");
          pill.setAttribute("aria-pressed", "true");
          showSummary();
        });
        timeList.appendChild(pill);
      });
    }

    function showSummary() {
      if (!state.selectedDate || !state.selectedTime) return;
      var dateLong = formatDateLong(state.selectedDate);
      summaryText.textContent =
        "Termin: " + dateLong + ", " + state.selectedTime + " Uhr";
      if (fieldDatum) fieldDatum.value = dateLong;
      if (fieldUhrzeit) fieldUhrzeit.value = state.selectedTime + " Uhr";
      if (fieldPLZ && state.plzInfo && !fieldPLZ.value) fieldPLZ.value = plzInput.value.trim();
      if (fieldOrt && state.plzInfo && !fieldOrt.value) fieldOrt.value = state.plzInfo.ort || "";
      stepSummary.hidden = false;
      if (form) {
        form.classList.remove("is-hidden");
        form.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }

    changeBtn.addEventListener("click", function () {
      state.selectedDate = null;
      state.selectedTime = null;
      Array.prototype.forEach.call(dateList.children, function (el) {
        el.classList.remove("is-selected");
        el.setAttribute("aria-pressed", "false");
      });
      stepTime.hidden = true;
      stepSummary.hidden = true;
      if (form) form.classList.add("is-hidden");
    });

    function checkPLZ() {
      var plz = plzInput.value.trim();
      if (!/^\d{5}$/.test(plz)) {
        showError("Bitte gib eine gültige 5-stellige Postleitzahl ein.");
        return;
      }
      showChecking();
      plzBtn.disabled = true;
      lookupPLZ(plz)
        .then(function (info) {
          plzBtn.disabled = false;
          if (!info) {
            showError(
              "Wir konnten diese Postleitzahl leider nicht zuordnen. Bitte prüfe deine Eingabe oder nutze unser Kontaktformular."
            );
            return;
          }
          var distance = haversineKm(CONFIG.COLOGNE_LAT, CONFIG.COLOGNE_LON, info.lat, info.lon);
          if (distance > CONFIG.MAX_DISTANCE_KM) {
            showError(
              "Aktuell ist hier leider kein Aufmaßservice möglich. Für eine Beratung nutzen Sie bitte unser Kontaktformular."
            );
            return;
          }
          state.plzInfo = info;
          showOk(info.ort, distance);
          stepDate.hidden = false;
          renderDates();
        })
        .catch(function () {
          plzBtn.disabled = false;
          showError(
            "Die Prüfung ist gerade nicht möglich. Bitte versuche es später erneut oder nutze unser Kontaktformular."
          );
        });
    }

    plzBtn.addEventListener("click", checkPLZ);
    plzInput.addEventListener("keydown", function (e) {
      if (e.key === "Enter") {
        e.preventDefault();
        checkPLZ();
      }
    });

    function showFormError(message) {
      if (!formErrors) return;
      formErrors.textContent = message;
      formErrors.hidden = false;
    }

    function hideFormError() {
      if (!formErrors) return;
      formErrors.hidden = true;
      formErrors.textContent = "";
    }

    if (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        hideFormError();

        // Honeypot: unsichtbares Feld, das nur Bots ausfuellen. Wird es
        // ausgefuellt, tun wir so, als waere alles ok, senden aber nichts.
        if (fieldBotcheck && fieldBotcheck.checked) {
          form.hidden = true;
          if (successBox) successBox.hidden = false;
          return;
        }

        if (window.AUFMASS_PREVIEW_MODE) {
          form.hidden = true;
          if (successBox) successBox.hidden = false;
          return;
        }

        var payload = {
          // Kontrollfelder fuer Web3Forms (erscheinen nicht als Zeile in der Mail):
          access_key: CONFIG.WEB3FORMS_ACCESS_KEY,
          botcheck: "",
          subject: "Neue Aufmaßtermin-Anfrage",
          // "email" muss exakt so heissen, damit Web3Forms Reply-To automatisch
          // auf die Kunden-Adresse setzt.
          email: fieldEmail ? fieldEmail.value : "",
          // Sichtbare Felder in der Mail, mit sprechenden Labels:
          Name: fieldName ? fieldName.value : "",
          Telefon: fieldPhone ? fieldPhone.value : "",
          Wunschtermin: (fieldDatum ? fieldDatum.value : "") + ", " + (fieldUhrzeit ? fieldUhrzeit.value : ""),
          Adresse: (fieldStrasse ? fieldStrasse.value : "") + ", " + (fieldPLZ ? fieldPLZ.value : "") + " " + (fieldOrt ? fieldOrt.value : ""),
          Anmerkung: fieldNote ? fieldNote.value : ""
        };

        submitBtn.disabled = true;
        submitBtn.textContent = "Wird gesendet …";

        fetch(CONFIG.WEB3FORMS_ENDPOINT, {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify(payload)
        })
          .then(function (res) {
            return res.json().then(function (data) {
              return { ok: res.ok && data.success, data: data };
            });
          })
          .then(function (result) {
            submitBtn.disabled = false;
            submitBtn.textContent = "Termin anfragen";
            if (!result.ok) {
              showFormError(
                "Die Anfrage konnte nicht gesendet werden. Bitte versuchen Sie es erneut oder nutzen Sie unser Kontaktformular."
              );
              return;
            }
            form.hidden = true;
            if (successBox) successBox.hidden = false;
          })
          .catch(function () {
            submitBtn.disabled = false;
            submitBtn.textContent = "Termin anfragen";
            showFormError(
              "Die Anfrage konnte nicht gesendet werden. Bitte versuchen Sie es erneut oder nutzen Sie unser Kontaktformular."
            );
          });
      });
    }
  });
})();
